/**
 * TutorApplicationRecordingScreen — l'enregistrement d'une réponse vidéo de la candidature (route
 * `video-recording`, l'ancien `VideoRecordingScreen`), poussé par la question avec `questionId` et
 * `testCategory`. Un fil : l'état (`useTutorApplicationRecordingState`), la page du DS.
 */
import React from "react"

import { TutorApplicationRecordingPage } from "../../../../../../design-system/tutor"
import { type TutorSpaceScreenProps } from "../tutorSpaceRouteTypes"
import { useTutorApplicationRecordingState } from "./useTutorApplicationRecordingState"

export function TutorApplicationRecordingScreen(props: TutorSpaceScreenProps) {
    const params = (props.route?.params ?? {}) as { questionId?: unknown }
    const recording = useTutorApplicationRecordingState(params.questionId)
    return <TutorApplicationRecordingPage {...recording} testID="tutor-application-recording" />
}
